import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { UploadGMPIs } from '~/components/Admin';
import { ServicesContext, useAdminService } from '~/services';
import { BSModal } from '~/components/Bootstrap';

export function CreateMaclModal() {
    const [errors, setErrors] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [name, setName] = React.useState('');
    const [show, setShow] = React.useState(false);
    const [storedFiles, setFiles] = React.useState<DropzoneFileType[]>([]);
    const context = React.useContext(ServicesContext);
    const { createMacl } = useAdminService();

    function close() {
        setShow(false);
        setFiles([]);
        setErrors([]);
        setLoading(false);
        setName('');
    }

    async function fileSuccess() {
        try {
            setLoading(true);
            await createMacl(name, storedFiles);
            if (storedFiles.length > 0) {
                context.alert.set(
                    'Upload successful. Your MACL results will be emailed upon completion.',
                    'success'
                );
            }
            close();
        } catch (e) {
            if (!Array.isArray(e?.response)) {
                setErrors(['An upload error occurred']);
            } else {
                setErrors(e.response.map((x: { message: string }) => x.message));
            }
        } finally {
            setLoading(false);
        }
    }

    return !context.user.isMACLAdmin() ? null : (
        <>
            <Button variant="primary" onClick={() => setShow(true)} className="me-2">
                <i className="fa-solid fa-plus" /> New MACL
            </Button>
            <BSModal
                show={show}
                onHide={close}
                aria-labelledby="macl-import-title"
                id="macl-import-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="macl-import-title" role="heading" aria-level={1}>
                        Create MACL
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-end">
                        <a href="/resources/help/zephyr-create-macl-sample.xlsx" target="_blank">
                            Download Import Template
                        </a>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="name" className="col-form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                className="form-control"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <UploadGMPIs
                        errors={errors}
                        setErrors={setErrors}
                        loading={loading}
                        setLoading={setLoading}
                        storedFiles={storedFiles}
                        setFiles={setFiles}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={close}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={fileSuccess}
                        disabled={loading || name.trim().length === 0}
                    >
                        {loading && (
                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                        )}
                        Submit
                    </Button>
                </Modal.Footer>
            </BSModal>
        </>
    );
}
